import React, { useEffect, useState } from 'react';
import {
    useAppSelector
} from 'hooks/redux';
import Cookies from 'js-cookie';
import {
    getTabs,
    getTickers,
    resetError,
    getTabById,
    getAreasByTabId
} from 'store/reducers/TabsSlice';
import {setActivePage} from 'store/reducers/QuotesPageReducer';
import errorNotification from 'utils/Notifications/Error'
import { useDispatch } from 'react-redux';
import {Grid} from 'components/common/Grid';
import { useDragContext } from 'components/drag';
import { deepEqual } from 'fast-equals';
import {
    setActivePageId
} from 'store/reducers/quotes';

const QuotesPageUpdater = () => {
    const dispatch = useDispatch();
    const pages = useAppSelector(state => state.quotesPage.pages);
    const active_page_id = useAppSelector(state => state.quotes.active_page_id);
    const {error, tabs, workspaces} = useAppSelector(state => state.tabs);
    const {dispatch: _dispatch} = useDragContext();
    const [memo_workspaces, set_memo_workspaces] = useState<any[]>([]);

    useEffect(() => {
        const check = deepEqual(memo_workspaces.slice().sort((a, b) => a?.id - b?.id), workspaces.slice().sort((a, b) => a?.id - b?.id));
        if ((!memo_workspaces.length && workspaces.length) || (!check && !memo_workspaces.some(x => x?.id === workspaces[0]?.id))) {
            set_memo_workspaces(workspaces);
        }
    }, [workspaces]);

    useEffect(() => {
        if (!memo_workspaces.length) {   
            return;
        }

        const new_drag_items = memo_workspaces.map((item, i) => ({
            id: item.id.toString(),
            value: i + 1
        }));
        _dispatch({
            type: 'SET_ITEMS',
            payload: new_drag_items
        });
    }, [memo_workspaces]);

    useEffect(() => {
        if (!active_page_id && pages?.length > 0) {
            const currentId = parseInt(Cookies.get('activePageId') as string)
            if (!currentId) {
                return;
            }
            dispatch(setActivePageId(currentId.toString()));
            dispatch(setActivePage(currentId));
        } else {
        }
    }, [tabs, pages])

    useEffect(() => {
        //dispatch(getTickers())
        dispatch(getTabs())
    }, [dispatch])

    useEffect(() => {
        if (!error) return
        errorNotification(error)
        dispatch(resetError())
    }, [error, dispatch])

    useEffect(() => {
        if (typeof active_page_id !== 'string' || (typeof active_page_id === 'string' && !active_page_id.length)) {
            return;
        }
        dispatch(getTabById(parseInt(active_page_id)));
        //@ts-ignore
        dispatch(getAreasByTabId({id: parseInt(active_page_id) }));
    }, [active_page_id])

    if (!active_page_id) {
        return <Grid w='100%' h='100%' justify='center' align='center'><h1>Выберите или создайте вкладку</h1></Grid>
    }
    return <></>
}

export default QuotesPageUpdater;